angular.module('Itao.IndicatorMap').directive('indicatorSelectBox', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorSelectBox.html',
    restrict: 'E',
    scope: {
      indicators: '=',
      selectedIndicator: '=',
      onIndicatorSelect: '&',
      deselectAllIndicators: "&"
    },
    link: function (scope) {
      scope.selectIndicator = function (indicator) {
        scope.deselectAllIndicators();
        scope.onIndicatorSelect({indicator: indicator})
      };
      scope.$watch('pattern', function (newValue) {
        if (newValue != undefined) {
          if (newValue.length > 0) {
            scope.$broadcast('angular-ui-tree:expand-all');
          } else {
            scope.$broadcast('angular-ui-tree:collapse-all');
          }
        }
      });
    }
  };
});
